import React, { useState } from 'react';
import './CachedImage.css';
import { ImagePreview } from './ImagePreview';

interface CachedImageProps {
  url: string;
  enablePreview?: boolean;
  canOpenPreview?: boolean;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
  onClick?: () => void;
}

export const CachedImage: React.FC<CachedImageProps> = ({
  url,
  enablePreview = true,
  canOpenPreview = false,
  className,
  style,
  alt,
  onClick,
}) => {
  const [showPreview, setShowPreview] = useState(false);

  if (!url || url.trim() === '') {
    return null;
  }
  const isAllowedSrc =
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('/');
  if (!isAllowedSrc) {
    return null;
  }

  const handleImageClick = () => {
    if (onClick) {
      onClick();
    } else if (canOpenPreview && enablePreview) {
      setShowPreview(true);
    }
  };

  return (
    <>
      <img
        src={url}
        alt={alt}
        className={className}
        style={{
          cursor: (canOpenPreview && enablePreview) || onClick ? 'pointer' : 'default',
          ...style,
        }}
        onClick={handleImageClick}
      />
      {enablePreview && showPreview && (
        <ImagePreview
          visible={showPreview}
          imagePath={url}
          onClose={() => setShowPreview(false)}
        />
      )}
    </>
  );
};

export default CachedImage;
